'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import { styled } from '@acko-tech/building-blocks.ui.common'

export const CategoryTitle = styled.div`
  font-size: 30px;
  font-weight: 700;
  text-transform: uppercase;
  @media (max-width: 700px) {
    font-size: 20px;
  }
`

export const CategoryPostsWrapper = styled.div`
  margin-top: 40px;
`
export const CategoryWrapper = styled.div`
  @media (max-width: 700px) {
    padding: 0 20px 20px 20px;
  }
`

export const ContentWrapper = styled.div.attrs((props: { isMobile: boolean }) => props)`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-areas: 'left right';
  grid-gap: 30px;
  @media (max-width: 700px) {
    display: block;
  }

  ${({ isMobile }) =>
    isMobile &&
    `
    @media (max-width: 1140px) {
    display: block;
    }
    `}
`

export const LeftContainer = styled.div`
  grid-area: left;
`

// Category styles

export const CategoryStyledTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 5px;
  cursor: pointer;
`
export const CategoryImage = styled.img`
  width: 150px;
  height: 150px;
  border: 1px solid black;
  border-radius: 10px;
  cursor: pointer;
  @media (max-width: 700px) {
    width: 80px;
    height: 80px;
  }
`
export const CategoryDate = styled.div`
  font-size: 11px;
  margin-bottom: 7px;
`
export const CategoryDescription = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin-top: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 60px;
  @media (max-width: 700px) {
    display: none;
  }
`
export const CategoryStyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-gap: 30px;
  padding-bottom: 60px;
  @media (max-width: 700px) {
    grid-template-columns: 80px 1fr;
    grid-gap: 15px;
    padding-bottom: 26px;
  }
`
export const CategoryContent = styled.div``
export const Link = styled.a`
  text-decoration: none;
  color: #414a53;
`
